module.exports = __webpack_public_path__ + "static/media/ServiceLandingSection02.87cdc488.png";